import React, { useContext, useRef, useState } from 'react';
import { FC } from 'react';
import ReactPaginate from 'react-paginate';
import { useRouter } from 'next/router';
import {
    Article,
    Articles,
    ArticlesDetail,
    ArticlesDetailAnnotation,
    ArticlesDetailDate,
    ArticlesDetailTitle,
    ArticlesImage,
    EmptyMessage,
    Wrapper,
} from '@components/Articles/Articles.elements';
import useTranslation from '@hooks/useTranslation';
import moment from 'moment';
import { ROUTES, TRAININGS_LIMIT_PER_PAGE, getImageBaseURL } from '../../constants';
import { IArticleItem } from '../../interfaces/Article';
import { FilterTypesInUrl } from '../../interfaces/Filter';

interface ArticlesProps {
    articles: IArticleItem[];
    count: number;
}

const ArticlesTemplate: FC<ArticlesProps> = ({ articles, count }) => {
    const { t } = useTranslation();

    const router = useRouter();

    const showMore = async (pagination: { selected: number }) => {
        router.replace({
            pathname: router.pathname,
            query: {
                ...router.query,
                [FilterTypesInUrl.PAGE]: pagination.selected + 1,
            },
        });
    };

    return (
        <Wrapper>
            <Articles>
                {articles?.length > 0 ? (
                    articles?.map((article, key) => (
                        <Article key={key}>
                            <ArticlesImage src={`${getImageBaseURL()}/media/articles/${article.photo}`} />
                            <ArticlesDetail>
                                <ArticlesDetailTitle onClick={() => router.push(`${ROUTES.ARTICLE}/${article.slug}`)}>
                                    {article.title}
                                </ArticlesDetailTitle>
                                <ArticlesDetailDate>
                                    <strong>{t('blog.publishDate')}:</strong>{' '}
                                    {moment(article.publicationDate).format('DD. MM. YYYY')}
                                </ArticlesDetailDate>
                                <ArticlesDetailAnnotation>{article.annotation}</ArticlesDetailAnnotation>
                            </ArticlesDetail>
                        </Article>
                    ))
                ) : (
                    <EmptyMessage>{t('blog.emptyMessage')}</EmptyMessage>
                )}
            </Articles>
            {articles?.length > 0 && articles?.length < count && (
                <ReactPaginate
                    breakLabel="..."
                    onPageChange={showMore}
                    nextLabel=">"
                    previousLabel="<"
                    pageRangeDisplayed={TRAININGS_LIMIT_PER_PAGE}
                    pageCount={count / TRAININGS_LIMIT_PER_PAGE}
                    renderOnZeroPageCount={null}
                    forcePage={Number(router.query[FilterTypesInUrl.PAGE]) - 1 || 0}
                    containerClassName="pagination"
                    activeClassName="active"
                />
            )}
        </Wrapper>
    );
};

export default ArticlesTemplate;
